// Schwellen und Farben fuer den AgeIndicator (SPEC-007).
// FIXME(SPEC-008): aus Settings-Tabelle laden, sobald Admin-UI bereit.

import { C } from '@/theme';

export type AlterKategorie = 'frisch' | 'spuerbar' | 'dringend' | 'kritisch';
export type AbholKategorie = 'fern' | 'bald' | 'heute' | 'ueberfaellig';

export const SCHWELLEN_ERFASST = {
  spuerbar: 8,
  dringend: 15,
  kritisch: 22
} as const;

export const SCHWELLEN_ABHOLUNG = {
  bald: 7,
  heute: 0
} as const;

// Farbpalette fuer die Indikator-Punkte. Werte aus der Stille-Buchkultur-
// Palette plus eine ergaenzende terracotta-mid. Sie faerbt auch den Text
// daneben („vor 15 Tagen") — E58: von #C26642 (3,85 : 1) auf #A8532F
// (5,15 : 1 auf Cream, 4,61 : 1 auf der Zebra-Zeile).
const TERRACOTTA_MID = '#A8532F';

export const FARB_ERFASST: Record<AlterKategorie, string> = {
  frisch: C.inkSoft,
  // E58: Gold (#B8A07A) hatte als Textfarbe nur 2,4 : 1 — Gold-Dunkel hält 5,8 : 1.
  spuerbar: C.goldDark,
  dringend: TERRACOTTA_MID,
  kritisch: C.coral
};

export const FARB_ABHOLUNG: Record<AbholKategorie, string> = {
  fern: C.inkSoft,
  bald: C.goldDark,
  heute: TERRACOTTA_MID,
  ueberfaellig: C.coral
};

export function kategorisiereAlter(tageSeit: number): AlterKategorie {
  if (tageSeit >= SCHWELLEN_ERFASST.kritisch) return 'kritisch';
  if (tageSeit >= SCHWELLEN_ERFASST.dringend) return 'dringend';
  if (tageSeit >= SCHWELLEN_ERFASST.spuerbar) return 'spuerbar';
  return 'frisch';
}

export function kategorisiereAbholung(tageBis: number): AbholKategorie {
  if (tageBis < 0) return 'ueberfaellig';
  if (tageBis === 0) return 'heute';
  if (tageBis <= SCHWELLEN_ABHOLUNG.bald) return 'bald';
  return 'fern';
}

// formatTageSeit/formatTageBis sind nach lib/format.ts umgezogen — dort
// stehen alle Zeit- und Datumsangaben zusammen (B85).
